// src/api/schemas.js
import { fetchAuthSession } from "aws-amplify/auth";

// Reuse your env var; fallback to "/api" if you later route via CloudFront
// const API_BASE = process.env.REACT_APP_API_BASE2 || "/api";

export async function getJWT() {
  const { tokens } = await fetchAuthSession();
  const jwt = tokens?.idToken?.toString(); // or accessToken
  if (!jwt) throw new Error("No JWT");
  return jwt;
}

// GET current user's schemas (backend should fallback to GLOBAL if user has none)
// export async function listSchemas() {
//   const r = await fetch(`${API_BASE}/schemas`, {
//     headers: { Authorization: `Bearer ${await getJWT()}` },
//   });
//   if (!r.ok) throw new Error(`listSchemas failed: ${r.status} ${await r.text()}`);
//   return r.json();
// }

// // POST create/update a schema
// export async function saveSchema(schema) {
//   const r = await fetch(`${API_BASE}/schemas`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${await getJWT()}`,
//     },
//     body: JSON.stringify(schema), // { name, definition, version?, schemaId? }
//   });
//   if (!r.ok) throw new Error(`saveSchema failed: ${r.status} ${await r.text()}`);
//   return r.json();
// }
